import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { EmailContactEdit } from "@/Patient/Components/Profile/ContactComponents/EmailContactEdit";

import styles from "./EmailsEdit.module.scss";

interface IEmailsEditProps {
    emails: Email[];
    doNotEmail: boolean;
    showWarningMessage: boolean;
    onAdd: () => void;
    onEmailChange?: (value: string, index: number) => void;
    onRemove: (email: Email) => void;
    onDoNotEmailChange?: (isChecked: boolean) => void;
    onContactTypeChange: (value: string, index: number) => void;
    onDefaultNotificationChange?: (isChecked: boolean, index: number) => void;
    onOkToContactChange?: (isChecked: boolean, index: number) => void;
}

function EmailsEdit(props: IEmailsEditProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <>
            <div>
                <span>{getText("EmailLabel")}</span>
            </div>
            <div>
                <div>
                    <table>
                        <table key="doNotEmailCheckTable">
                            <tbody>
                                <tr>
                                    <td className="c1" />
                                    <td className="c2">
                                        <CheckboxControl
                                            id="doNotEmailCheck"
                                            dataCy="patientProfile-contacts-email-donotEmailCheck"
                                            key="doNotEmailCheck"
                                            checked={props.doNotEmail}
                                            onChange={checked => props.onDoNotEmailChange(checked)}
                                            label={getText(props.showWarningMessage ? "DoNotEmailWithEmailRemovedLabel" : "DoNotEmailLabel")}
                                        />
                                    </td>
                                    <td className="c3" rowSpan={3} />
                                </tr>
                            </tbody>
                        </table>
                        {!props.doNotEmail && props.emails
                            .map((email, idx) => (
                                <EmailContactEdit
                                    key={`email_${email.ContactPoint_id}`}
                                    email={email}
                                    onRemove={() => props.onRemove(email)}
                                    onContactTypeChange={value => props.onContactTypeChange(value, idx)}
                                    onEmailChange={value => props.onEmailChange(value, idx)}
                                    onDefaultNotificationChange={checked => props.onDefaultNotificationChange(checked, idx)}
                                    onOkToContactChange={checked => props.onOkToContactChange(checked, idx)}
                                />
                            ))
                        }
                        <div key="addEmail" className="text-right">
                            <a
                                onClick={() => !props.doNotEmail && props.onAdd()}
                                className={styles.addLabel}
                            >
                                {getText("AddLabel")}
                            </a>
                        </div>
                    </table>
                </div>
            </div>
        </>
    );
}

export { EmailsEdit };
